export default __webpack_public_path__ + "static/media/abcdropoptions.9bc6d26e.png";